import { createStyles, makeStyles } from '@material-ui/core/styles'

export const useStyles = makeStyles(() =>
  createStyles({
    container: {
      marginTop: '1rem',

      display: 'flex',
      justifyContent: 'space-between',

      '& button': {
        width: '4.3rem',
        height: '3.6rem',
        margin: 0,
        padding: 0,

        '& .rotate': {
          transform: 'rotate(180deg)',
        },
      },
    },
    tooltip: {
      backgroundColor: '#505356',
      color: '#FFFFFF',

      maxWidth: '30rem',
      fontSize: '1.2rem',
      fontWeight: 600,

      border: 'none',
      borderRadius: 5,
    },
    tooltipPlacementTop: {
      marginBottom: 4,
    },
  }),
)
